import {z} from 'zod';

import i18n from '@dms/i18n';

export interface RecordAuditDefinitionTask {
  description: string;
  isMandatory: boolean;
  fileRequired: boolean;
  weight: number;
  sectionId: string | null;
  id?: string;
}

export interface RecordAuditDefinitionSection {
  id: string;
  name: string;
}

export const recordAuditDefinitionFormSchema = z.object({
  name: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  resourceId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  description: z.string().nullish(),
  category: z.string().nullish(),
  successThreshold: z.number().int().min(1).max(100).nullable(),
  sections: z.array(
    z.object({
      id: z.string(),
      name: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
    })
  ),
  tasks: z.array(
    z.object({
      description: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
      isMandatory: z.boolean(),
      fileRequired: z.boolean(),
      weight: z.number().int().min(1).max(5),
      sectionId: z.string().nullable(),
      id: z.string().nullish(),
    })
  ),
});

export type RecordAuditDefinitionFormValue = z.infer<typeof recordAuditDefinitionFormSchema>;
